import React from 'react';
import { ManageListingsContextProvider } from './ManageListingsContext';
import ManageListingsLayout from './ManageListingsLayout';

const ManageListings: React.FC = () => (
    <ManageListingsContextProvider>
      <ManageListingsLayout />
    </ManageListingsContextProvider>
  );

export default ManageListings;
